import React from "react";
import { Link } from "react-router-dom";
import { SubscriptionBreadCrumbDisplay } from "./SubscriptionBreadCrumbDisplay";

interface BreadCrumbProps {
	productId: string;
	subscriptionId: string;
}

/**
 * This component is the subscription sub navigation breadcrumb display.
 * Currently it just takes in a lisk of elements (react router links in most cases)
 * and displays them with ' > ' in between.
 * @param breadCrumbProps
 */
export const SubscriptionBreadCrumbComponent = (props: BreadCrumbProps) => {
	const breadCrumbs = [
		<Link key={"SubscriptionsLink"} to={`/Products/${props.productId}/Subscriptions`}>
			Subscriptions{" "}
		</Link>,
		<span key={props.subscriptionId}>
			<SubscriptionBreadCrumbDisplay
				subscriptionId={props.subscriptionId}
				productId={props.productId}
			></SubscriptionBreadCrumbDisplay>
		</span>,
	];

	return (
		<span>
			{breadCrumbs.map((crumb, index) => {
				return (
					<span key={index}>
						{index !== 0 && <span> {" > "} </span>}
						{crumb}
					</span>
				);
			})}
		</span>
	);
};
